var _mask, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 98,
    viewBox: "0 0 114 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5208_6361",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4892 0L23.5674 27.702V63L50.4892 90H86.385L113.307 63V27.702L86.385 0H50.4892Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4892 0V-100C23.4724 -100 -2.39498 -89.0684 -21.224 -69.6937L50.4892 0ZM23.5674 27.702L-48.1459 -41.9917C-66.2851 -23.3268 -76.4326 1.67488 -76.4326 27.702H23.5674ZM23.5674 63H-76.4326C-76.4326 89.4714 -65.9367 114.863 -47.2457 133.608L23.5674 63ZM50.4892 90L-20.3239 160.608C-1.56195 179.424 23.9174 190 50.4892 190V90ZM86.385 90V190C112.957 190 138.436 179.424 157.198 160.608L86.385 90ZM113.307 63L184.12 133.608C202.811 114.863 213.307 89.4714 213.307 63H113.307ZM113.307 27.702H213.307C213.307 1.67488 203.159 -23.3268 185.02 -41.9917L113.307 27.702ZM86.385 0L158.098 -69.6937C139.269 -89.0684 113.402 -100 86.385 -100V0ZM-21.224 -69.6937L-48.1459 -41.9917L95.2807 97.3957L122.203 69.6937L-21.224 -69.6937ZM-76.4326 27.702V63H123.567V27.702H-76.4326ZM-47.2457 133.608L-20.3239 160.608L121.302 19.3919L94.3805 -7.60812L-47.2457 133.608ZM50.4892 190H86.385V-10H50.4892V190ZM157.198 160.608L184.12 133.608L42.4938 -7.60812L15.5719 19.3919L157.198 160.608ZM213.307 63V27.702H13.3069V63H213.307ZM185.02 -41.9917L158.098 -69.6937L14.6718 69.6937L41.5936 97.3957L185.02 -41.9917ZM86.385 -100H50.4892V100H86.385V-100Z",
    fill: "#F0C9C9",
    mask: "url(#path-1-inside-1_5208_6361)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 68.9332V37.7314L29.0349 13H60.7046L84.7395 37.7314V68.9332L60.7423 93H28.9972L5 68.9332Z",
    stroke: "#FF0000",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 56.0234H59.0937V53.0234V50.0234H30V53.0234V56.0234Z",
    stroke: "#FF0000",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecline);
export default __webpack_public_path__ + "static/media/decline.cd010b9052d92bd5b0397471bf69209b.svg";
export { ForwardRef as ReactComponent };